import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'kangarootime-ui';
import ListItem from '../ListItem';
import ChannelGroup from '../ChannelGroup';

const HASHTAG_DECIMAL_CHAR_CODE = String.fromCharCode(35);
const LOCK = <Icon icon='lock' color='#AB9BA9' height={24} width={24} />;

const Channels = ({
  activeChannelId,
  onChannelSelect,
  channels,
  createNewChannel,
  channelsWithNewMessages,
  showChannelsAtCenter,
  ...props
}) => {
  return (
    <ChannelGroup
      groupTitle='Channels'
      tooltip='Create a channel'
      onGroupTitleClick={showChannelsAtCenter}
      createChannel={createNewChannel}
    >
      { channels.map(channel => {
        const { id, name, private: isPrivateChannel } = channel;
        const channelIcon = isPrivateChannel ? LOCK : HASHTAG_DECIMAL_CHAR_CODE;

        return (
          <ListItem
            isActive={activeChannelId === id}
            showBadge={false}
            messageCount={channelsWithNewMessages[id] || 0}
            key={`channel-${id}`}
            onClick={() => onChannelSelect(id, channel)}
          >{channelIcon} {name}</ListItem>
        );
      })}
    </ChannelGroup>
  );
};

Channels.propTypes = {
  channels: PropTypes.array,
  activeChannelId: PropTypes.string,
  onChannelSelect: PropTypes.func,
  createNewChannel: PropTypes.func,
  showChannelsAtCenter: PropTypes.func,
  channelsWithNewMessages: PropTypes.shape({
    [PropTypes.number]: PropTypes.bool
  })
};

Channels.defaultProps = {
  channelsWithNewMessages: {}
};

export default Channels;
